import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/investment-analysis/components/InvestmentAnalysisInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
